import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn.js";

type Tone = "neutral" | "success" | "warning" | "danger" | "info";

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
}

const TONE_CLASS: Record<Tone, string> = {
  neutral: "bg-surface-raised text-text-secondary border-surface-border",
  success: "bg-status-success/15 text-status-success border-status-success/30",
  warning: "bg-status-warning/15 text-status-warning border-status-warning/30",
  danger: "bg-status-danger/15 text-status-danger border-status-danger/30",
  info: "bg-accent-subtle text-accent border-accent/30"
};

export function Badge({ tone = "neutral", className, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-sm border px-1.5 py-0.5 text-xxs font-medium uppercase tracking-wide",
        TONE_CLASS[tone],
        className
      )}
      {...rest}
    />
  );
}
